import { useCurrentUser } from './use-current-user';
import { useOrganizationSelector } from './use-organization-selector';

/**
 * Hook to get the current user's organization ID
 * Returns the organization ID from the user's current organization context
 * For contractors: uses selected organization
 * For employees: uses their single organization
 */
export function useCurrentOrganization() {
  const { user, isLoading, error } = useCurrentUser();
  const { activeOrganizationId, activeOrganizationName, isContractor, canSelect } = useOrganizationSelector();
  
  // Use selected organization for contractors, fallback to user's organization for employees
  const organizationId = activeOrganizationId || (user as any)?.organizationId || null;
  const organizationName = activeOrganizationName || (user as any)?.organizationName || null;
  
  return {
    organizationId,
    organizationName,
    isLoading,
    error,
    hasOrganization: !!organizationId,
    isContractor,
    canSelectOrganization: canSelect
  };
}
